<div class="dialog-container">
  <mat-dialog-content> Your feedback has been submitted! Thank you for helping us improve Core. </mat-dialog-content>

  <mat-dialog-actions>
    <button class="btn close-button" mat-dialog-close (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
</div>
